module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapping"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', [_vm._v("尊敬的" + _vm._s(_vm.hcgInfo.name))]), _vm._v(" "), _c('p', [_vm._v("注射夜针" + _vm._s(_vm.hcgInfo.hcgTime) + "，请提前十分钟到 8楼住院部，合理安排全程，不要迟到。")]), _vm._v(" "), _c('h4', [_vm._v("注意事项：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.hcgInfo.vfhcgTime) + "，双方正常生活、饮食，不剧烈运动。晚上十点以后女方禁饮、禁食，直到手术结束。")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.hcgInfo.vshcgTime) + "，早上08:00先到 14楼前台报到 ，安排手术。")]), _vm._v(" "), _c('p', [_vm._v("男方如有取精困难请提前告知我们")]), _vm._v(" "), _c('p', [_vm._v("手术完成前禁止：喝水、吃东西、戴首饰、香水、化妆、美甲、戴假牙")]), _vm._v(" "), _c('p', [_vm._v("必须带：双方的身份证和结婚证(两本) “原件”")]), _vm._v(" "), _c('h4', [_vm._v("取卵流程：")]), _vm._v(" "), _vm._m(0, false, false)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": "加载中..."
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    attrs: {
      "src": "http://front.wh.jinxin-fertility.com/static/images/viphcg.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cef79cf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/vipMsg/vipHcgMsg.vue
// module id = YTqi
// module chunks = 7